import Polygon from './Polygon'
import AdvancedMarker from './AdvancedMarker'

export default class GoogleMap {
  constructor(el, infoWindows) {
    this.el = el
    this.map = null
    this.markers = []
    this.resizeTimeout = null
    this.infoWindows = infoWindows
    this.initMap()
  }

  initMap() {
    // The map, centered at the center point
    this.map = new window.google.maps.Map(this.el, {
      zoom: 13,
      maxZoom: 16,
      center: { lat: 46.8184431, lng: -71.2016063 },
      disableDefaultUI: true,
      zoomControl: true,
      mapId: 'b90909763979696b',
    })

    this.markersByType = {}
    // Add markers for each point
    this.points = JSON.parse(this.el.dataset.points)
    this.setMarkers()

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(this.resetMapBounds.bind(this), 250)
    })

    return this.map
  }

  resetMapBounds() {
    const bounds = new window.google.maps.LatLngBounds()
    const visibleMarkers = this.markers.filter((marker) => marker.visible)

    visibleMarkers.forEach((marker) => {
      bounds.extend(marker.instance.position)
    })

    if (this.map) {
      if (visibleMarkers.length > 0) {
        this.map.fitBounds(bounds)
      } else {
        this.map.setCenter({ lat: 46.8184431, lng: -71.2016063 })
        this.map.setZoom(13)
      }
    }
  }

  clearMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null)
    }
    this.markers = []
  }

  setMarkers() {
    this.clearMarkers()

    this.points.forEach((point, i) => {
      this.createMarker(point, i)
    })

    this.resetMapBounds()
  }

  createMarker(point, i) {
    const marker = new AdvancedMarker(this.map, point, i)

    marker.instance.addListener('click', () => {
      const element = document.querySelector(`#info-window-${point.id}`)

      if (element) {
        const infoWindow = this.infoWindows[i]
        infoWindow.instance.togglePopup()

        element.focus()
      }
    })

    if (point.type) {
      this.markersByType[point.type] = this.markersByType[point.type] || []
      this.markersByType[point.type].push(marker)
    }

    if (point.polygon) {
      new Polygon(this.map, JSON.parse(point.polygon))
    }

    this.markers.push(marker)
  }
}
